import React from 'react';
import { Section } from './Section';
export function Method() {
  return <Section id="metodo" eyebrow="La revelación" data-id="element-63" data-mp="72vfwl1l11v4">
      <h2 className="font-display text-4xl font-extrabold uppercase leading-none text-white sm:text-5xl" data-id="element-64" data-mp="71kcimc1tw4j">
        El Método Híbrido 2.0
      </h2>
      <p className="mt-6 text-lg leading-relaxed text-zinc-400" data-id="element-65" data-mp="h11gmzbnk1ye">
        La programación definitiva de{' '}
        <strong className="font-semibold text-white" data-id="element-66" data-mp="3fiyrh1vtfaoq">12 semanas</strong> que elimina las
        suposiciones.
      </p>

      <img src="https://cdn.magicpatterns.com/patterns/generated-images/9059446e-a73c-4514-a52c-8f3e66115bca.jpg" alt="Bundle del Método Híbrido 2.0: manual, plan de 12 semanas y calculadora de ritmos" className="mt-8 w-full rounded-xl border border-ink-700" loading="lazy" data-id="element-67" data-mp="3kh0axnx5lc0q" />

      <p className="mt-8 text-lg leading-relaxed text-zinc-400" data-id="element-68" data-mp="2wre9sux80mq3">
        No es magia, es{' '}
        <strong className="font-semibold text-white" data-id="element-69" data-mp="31q8u61au6jcb">periodización científica</strong>.
        Aprenderás a programar tus sesiones de fuerza y tus rodajes de carrera para
        optimizar la recuperación celular, ganar masa muscular y aumentar tu capacidad
        aeróbica al mismo tiempo.
      </p>
      <p className="mt-6 font-display text-3xl font-extrabold uppercase italic text-white" data-id="element-70" data-mp="foadryxu6qru">
        Un cuerpo atlético, funcional y estético. Sin excusas.
      </p>
    </Section>;
}